export class GlobalContextEventTypes {
  public static readonly notifyingGlobalAlert = 'GLOBAL_ALERT';
  public static readonly closeAllGlobalAlert = 'CLOSE_GLOBAL_ALL_ALERT';
}
